<template>
  <div class="nav">
    <div class="main">
      <!-- pc -->
      <img
        class="pc-logo"
        src="@/assets/images/pc/logo.png"
        alt=""
      />
      <button
        type="button"
        :disabled="disabled"
        @click="$emit('download')"
        class="download"
      >
        <img
          src="@/assets/images/pc/download.png"
          alt="下載 App"
        />
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({ disabled: Boolean });
defineEmits(['download']);
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';

.nav {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  width: 100%;
  max-width: $pc-max-width;
  height: 1.2rem;
  background: #ffffff;

  .main {
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 62.5%;
    max-width: $pc-main-max-width;
  }

  .pc-logo {
    display: flex;
    margin: 0.25rem auto auto 0.7rem;
    width: 2.3rem;
    height: auto;
  }

  .mobile-logo {
    display: none;
  }

  .download {
    display: flex;
    align-items: center;
    width: 2.3rem;
    padding: 0;
    background: none;
    border: 0;
    cursor: pointer;

    img {
      width: 100%;
    }
  }
}

@media (max-width: 768px) {
  .nav {
    display: none;
  }
}
</style>
